
import config from '../js/config';

let promotionsServiceInstance;

export class PromotionsService {
  static getInstance() {
    if (!promotionsServiceInstance) {
      promotionsServiceInstance = new PromotionsService();
    }
    return promotionsServiceInstance;
  }

  getPromotionalProductsToRemove(salesOrder) {
    let promoSettings = config.cartPromotionSettings;
    let productsToRemove = [];
    let arePromotionsEnabled = promoSettings && promoSettings.enabled;
    let hasOrderEntries = salesOrder.entries && salesOrder.entries.length;
    if (arePromotionsEnabled && hasOrderEntries && !promoSettings.promoFallbackEnabled) {
      for (let i = 0; i < salesOrder.entries.length; i++) {
        let matchesProductId = this.doesProductMatchPromoProduct(salesOrder.entries[i], promoSettings.promotionProductId);
        let matchesProductCatalogId = this.doesProductMatchPromoProduct(salesOrder.entries[i], promoSettings.promotionProductCatalogId);
        if (matchesProductId || matchesProductCatalogId) {
          productsToRemove.push(salesOrder.entries[i]);
        }
      }
    }
    return productsToRemove;
  }

  doesProductMatchPromoProduct(product, promoProductId) {
    return (promoProductId === product.catalogSourcePartId || promoProductId === product.catalogSourceId);
  }
}



// WEBPACK FOOTER //
// ./assets/services/PromotionsService.js